import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, enableDebugTools } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import Swal from 'sweetalert2';

import { GoogleLocationModalComponent } from '@teem/store-module/modals/google-location-modal/google-location-modal.component';
import { BranchModalComponent } from '@teem/store-module/modals/branch-modal/branch-modal.component';
import { DeliveryComponent } from '@teem/store-module/components/product-information/components/delivery/delivery.component';
import { StoreInformationService } from '@teem/services/store-information.service';
import { SharedDataService } from '@teem/services/shared-data.service';
import { LoaderService } from '@teem/services/loader.service';
import { uniqueSlugValidator } from '@teem/app/core/utils/email-unique.validator';

import { messages as i18n } from '@teem/constants/messages';
import { category as CategoryApi, country } from '@teem/constants/api';

import { country as CountryApi } from '@teem/core/constants/api';
import { fileNameFromUrl } from '@teem/helpers/functions';
import { CITY, SAUDI_ARABIA } from '@teem/core/constants/country';
import { STORE_TYPE } from '@teem/core/constants/defaults';
import { environment } from '@teem/environments/environment';
import { ExtraValidators } from '@teem/utils/ExtraValidators';
import { pad } from '@teem/helpers/functions';
import Survicate from '@survicate/survicate-web-package/survicate_widget';
import { CouponService } from '@teem/app/core/services/coupon.service';
import { StoreServiceService } from '@teem/app/core/services/store-service.service';
declare var $: any;

@Component({
  selector: 'product-information',
  templateUrl: './product-information.component.html',
  styleUrls: ['./product-information.component.scss']
})
export class ProductInformationComponent implements OnInit {
  readonly CITY: any = CITY;
  @ViewChild('logoFile') myPond: any;
  @Output() onBusinessTypeChange: EventEmitter<any> = new EventEmitter();
  @Input() myStoreType;
  defaultBranch: any;
  branches: any;
  selectedBranch: any = null;
  selectedBranchId: any = '';
  showBranches: boolean = false;
  productCategoriesApi: string = CategoryApi.productCategoriesList;
  storeFrontCategoriesApi: string = CategoryApi.storeFrontCategoriesApi;
  countryListApi: string = CountryApi.endPoint;
  regionListApi: string = CountryApi.regions;
  cityListApi: string = CountryApi.cities;
  isAllowFoodicsSync: boolean = true;
  isAllowDeliveryPaymentPartners: boolean = true;
  isAllowPromocodes: boolean = true;
  isAllowDeliveryDiscounts: boolean = true;
  routeSubscriber: any;
  basicInfo: any;
  storeUrl: any;
  storeInformationForm: FormGroup;
  deliveryForm: FormGroup;
  storeInfo: any = {};
  isSubmitted: boolean = false;
  showOtoFrom: boolean = false;
  otoAccountType: string = 'new_account'
  coverImageFile: any = null;
  coverImageUrl: any = '';
  selectedProductCategories: Array<any> = [];
  selectedStorefrontCategories: Array<any> = [];
  shopStatus: any;
  cities: any = '';
  districts: any = '';
  selectedCountry: any;
  selectedDistrict: any;
  selectedRegion: any;
  selectedCity: any;
  // isLogistiq: boolean = false;
  foodicsEnabled: boolean = false;
  autoAccept: any;
  isMawjood: boolean = false;
  outsideSA: boolean = true;
  activeTab = 'general';
  foodicsDataFetched: boolean = false;
  productListingType: string = null;
  deliveryDiscounts: any = {};
  startTimeAM: boolean = true;
  endTimeAM: boolean = true;
  selectedWeekDays: Array<any> = [];
  hours: Array<string> = [];
  minutes: Array<string> = [];
  moment: any = moment;
  weekDays: any = [
    { value: 'sunday', label: 'Sunday' },
    { value: 'monday', label: 'Monday' },
    { value: 'tuesday', label: 'Tuesday' },
    { value: 'wednesday', label: 'Wednesday' },
    { value: 'thursday', label: 'Thursday' },
    { value: 'friday', label: 'Friday' },
    { value: 'saturday', label: 'Saturday' }
  ];

  // days: any = ['Sun', 'Mon'];
  // array1: FormArray;
  // model1: any = [
  //   { day: 'Sun', start_time: '06:00', end_time: '12:30' },
  //   { day: 'Mon', start_time: '06:00', end_time: '12:30' },
  //   { day: 'Tue', start_time: '06:00', end_time: '12:30' },
  // ];

  timeModel: any = {
    sunday: false,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
  }

  // Ref: https://pqina.nl/filepond/docs/patterns/api/server/
  uploadToServer = {
    process: (fieldName, file, metadata, load, error, progress, abort) => {
      let oldFileName = this.coverImageUrl ? fileNameFromUrl(this.coverImageUrl) : null;
      let timer;
      if (oldFileName != file.name) {
        // Create data object containing the file and the file metadata
        const formData = new FormData();
        formData.append('logo_image', file, file.name);
        formData.append('store_type', STORE_TYPE.PRODUCT);
        formData.append(fieldName, JSON.stringify(metadata));

        this.storeInformationService.uploadFile(formData).subscribe(
          (data: any) => { 
            this.coverImageFile = data.body?.cover_image;
            this.coverImageUrl = this.coverImageFile;
          },
          (err) => { console.error(`File Upload Error: ${err.message}`); },
        );
        // Progress indicator supported, set progress to 25% of 1
        progress(true, 0.25, 1);
        // Fake completion after 1 second
        timer = setTimeout(() => {
          load(file); // or { body: 'unique-file-id' }
        }, 1000);
      } else {
        load(this.coverImageUrl);
        progress(false);
      }

      // Should expose an abort method so the request can be cancelled by the user
      return {
        abort: () => {
          // abort your request here (we clear timer for demo purposes)
          clearTimeout(timer);
          // updates FilePond interface
          abort();
        }
      };
    },

    revert: (uniqueFileId, load, error) => {
      // remove file from server here

      this.storeInformationService.removeFile(STORE_TYPE.PRODUCT).subscribe(
        (data) => {
          // console.log(data);
          load();
        },
        (err) => { console.error(`Remove File Upload Error: ${err.message}`); },
      );
      // console.log("deleted  ", uniqueFileId);
    }
  };

  pondOptions = {
    multiple: false,
    // allowRevert: false,
    allowReplace: false,
    allowRemove: true,
    allowImageResize: true,
    allowImagePreview: true,
    // labelIdle: `
    // <div style="text-align: center">
    // 	<p>${i18n.drag_and_drop_file}</p>
    // </div>`,
    imageResizeMode: 'cover',
    imagePreviewHeight: 300,
    imagePreviewMinHeight: 300,
    imagePreviewMaxHeight: 300,
    imageResizeTargetWidth: 700,
    imageResizeTargetHeight: 300,
    server: this.uploadToServer,
    acceptedFileTypes: 'image/png, image/jpeg, image/gif',
    labelIdle: `<span class="icon-upload"></span>`,
    beforeRemoveFile: this.pondHandleRemoveFile,
  };

  constructor(
    private formBuilder: FormBuilder,
    private storeInformationService: StoreInformationService,
    private CouponService: CouponService,
    private loaderService: LoaderService,
    private router: Router,
    private route: ActivatedRoute,
    private sharedDataService: SharedDataService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private storeService: StoreServiceService
  ) {
    this.createStoreFormGroup();
  }

  pondHandleInit() {
    // console.log('FilePond has initialized', this.myPond);
  }

  pondHandleAddFile(event: any) {
    // console.log('A file was added', event);

  }

  async pondHandleRemoveFile(event: any) {
    let confirm = await Swal.fire({
      title: i18n.are_you_sure,
      text: i18n.store.delete_cover_image_confirm,
      icon: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: i18n.yes,
      cancelButtonText: i18n.no_cancel_it
    })
    if (confirm.isConfirmed) {
      return true
    }
    return false;
  }

  ngOnInit(): void {
    const deliveryOptions = this.route.snapshot.queryParamMap.get('delivery-options');
    if (deliveryOptions === '1') {
      this.activeTab = 'delivery-options';
    }

    this.routeSubscriber = this.route.queryParams.subscribe(params => {
      if (params && params['product-listing']) {
        this.activeTab = 'product-listing';
      }
    });

    // this.array1 = this.formBuilder.array(this.model1.map(x => this.formBuilder.group({
    //   day: this.formBuilder.control(x.day),
    //   start_time: this.formBuilder.control(x.start_time),
    //   end_time: this.formBuilder.control(x.end_time),
    // })));
    this.basicInfo = (window as any).userInfo;
    this.sharedDataService.asObservable().subscribe((data) => {
      if (data && data.userInfo) {
        Survicate.init({
          workspaceKey: environment?.survicate_key,
          disableTargeting: true,
          traits: {
            id: data.userInfo.id,
            email: data.userInfo.email
          }
        });
        this.basicInfo = data.userInfo;


        if (this.basicInfo?.subscription?.subscription_plan == "online-store-basic" || this.basicInfo?.subscription?.subscription_plan == "online-ordering-basic") {
          this.isAllowFoodicsSync = false;
          this.isAllowDeliveryPaymentPartners = false;
          this.isAllowPromocodes = false;
          this.isAllowDeliveryDiscounts = false;
        }

        this.foodicsDataFetched = this.basicInfo?.marketplace_model?.is_products;
        this.storeInformationForm.get('name').setValue(this.basicInfo.business_name);
        this.storeInformationForm.get('phone').setValue(this.basicInfo.phone);
        // this.storeInformationForm.get('city').setValue(this.basicInfo.city);
        // this.storeInformationForm.get('district').setValue(this.basicInfo.district);
        // this.storeInformationForm.get('region').setValue(this.basicInfo.region);
        this.productListingType = 'manual';
        if (this.foodicsAvailble() && this.isAllowFoodicsSync) {
          this.productListingType = 'foodics';
        }

        if (this.basicInfo?.is_oto_info) {
          this.showOtoFrom = true;
        }
      }
    })

    for (let i = 0; i <= 23; i++) {
      this.hours.push(pad(i, 2, 0))
    }

    for (let j = 0; j <= 59; j++) {
      this.minutes.push(pad(j, 2, 0))
    }

    this.fetchStoreInfo();

    // this.deliveryForm = this.formBuilder.group({
    //   delivery_discount: [1, Validators.required],
    //   discount_expiry: [null, Validators.required],
    //   minimum_order_size: [null, Validators.required],
    //   minimum_discount_size: [null, Validators.required]
    // });
  }

  convertToSlug(input: string) {
    let slug = input.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
    this.storeInformationForm.get('slug').setValue(slug);
    this.storeUrl = `${environment.baseUrl}/${this.storeInformationForm.get('slug').value}`;
  }

  // fetchStoreInfo() {
  //   this.loaderService.startLoading();

  //   this.storeInformationService.getProductInfo().subscribe((data: any) => {
  //     if (!data.error) {
  //       this.storeInfo = data;
  //       this.storeInformationForm.patchValue(data);
  //       if (data.city_id == CITY.JEDDAH) {
  //         this.isLogistiq = true
  //       }

  //       this.coverImageUrl = this.storeInfo.cover_image;

  //       if (data.days && (data.days?.length > 0)) {
  // 				this.selectedWeekDays = data.days.map((day) => day.day);
  // 				// let days = data.days;
  // 				// let startTime = moment(days[0].opening_time, 'HH:mm:ss');
  // 				// let endTime = moment(days[0].closing_time, 'HH:mm:ss');

  // 				// // // Ignore seconds in start_time and end_time - because we can't change seconds and it's causing issue in validation
  // 				// this.storeInformationForm.get('start_time').setValue(startTime.format('HH:mm') == '00:00' ? '' : startTime.format('HH:mm') + ":00");
  // 				// this.storeInformationForm.get('end_time').setValue(endTime.format('HH:mm') == '00:00' ? '' : endTime.format('HH:mm') + ":00");

  // 				// this.storeInformationForm.get('start_time_group').setValue({
  // 				// 	hours: startTime.format('hh'),
  // 				// 	minutes: startTime.format('mm'),
  // 				// 	am: startTime.hours() < 12
  // 				// })

  // 				// this.storeInformationForm.get('end_time_group').setValue({
  // 				// 	hours: endTime.format('hh'),
  // 				// 	minutes: endTime.format('mm'),
  // 				// 	am: endTime.hours() < 12
  // 				// });

  //         this.storeInformationForm.get('week_days.same_everyday').setValue(data?.same_everyday);

  //         // new UI
  //         data.days.forEach((app) => {
  //           if (app.day) {
  //             let day = app.day;
  //             let startTime = moment(app.opening_time, 'HH:mm:ss');
  //             let endTime = moment(app.closing_time, 'HH:mm:ss');

  //             this.storeInformationForm.get('week_days.'+day+'.available').setValue(true);
  //             this.storeInformationForm.get('week_days.'+day+'.start_time').setValue(startTime.format('HH:mm:ss'));
  //             this.storeInformationForm.get('week_days.'+day+'.end_time').setValue(endTime.format('HH:mm:ss'));

  //             this.storeInformationForm.get('week_days.'+day+'.new_start_time_group').setValue({
  //               hours: startTime.format('HH'),
  //               minutes: startTime.format('mm')
  //             });

  //             this.storeInformationForm.get('week_days.'+day+'.new_end_time_group').setValue({
  //               hours: endTime.format('HH'),
  //               minutes: endTime.format('mm')
  //             });

  //             this.timeModel[day] = true;
  //           }
  //         });
  // 			}

  //       this.shopStatus = data.active === 0 ? false : true;
  //       this.autoAccept = data.auto_accept === 0 ? false : true;

  //       if (data.country_id == SAUDI_ARABIA) {
  //         this.outsideSA = false;
  //       }

  //       if (data.country_id) {
  //         this.selectedCountry = {
  //           id: data.country_id,
  //           name: data.country_name
  //         }
  //         this.storeInformationForm.get('country_id').setValue(data.country_id);
  //         this.onChangeCountry(this.selectedCountry);
  //       }

  //       if (data.region_id) {
  //         this.selectedRegion = {
  //           id: data.region_id,
  //           name: data.region_name
  //         }
  //         this.storeInformationForm.get('region_id').setValue(data.region_id);
  //         // this.onChangeRegion(this.selectedRegion);
  //       }

  //       if (data.city_name) {
  //         this.storeInformationForm.get('city').setValue(data.city_name);
  //       }

  //       if (data.city_id) {
  //         this.selectedCity = {
  //           id: data.city_id,
  //           name: data.city_name
  //         }
  //         this.storeInformationForm.get('city_id').setValue(data.city_id);
  //         // this.onChangeCity(this.selectedCity);
  //       }

  //       if (data.district_id) {
  //         this.selectedDistrict = {
  //           id: data.district_id,
  //           name: data.district_name
  //         }
  //         this.storeInformationForm.get('district_id').setValue(data.district_id);
  //       }

  //       if (data.slug){
  //         this.storeUrl = `${environment.baseUrl}/${data.slug}`;
  //       }

  //       if (data.product_categories) {
  //         this.selectedProductCategories = data.product_categories.map((item) => item.name);
  //       }

  //       if (data.storefront_categories) {
  //         this.selectedStorefrontCategories = data.storefront_categories;
  //       }

  //       if (!data.shop_comments) {
  //         this.storeInformationForm.get('allow_shop_comment').setValue(0);
  //         // $("#checkbox-005").slideToggle();
  //         // $("#shop-comments").hide();
  //         // $("#shop-comments").addClass('d-none');
  //         let shop_comments = this.storeInformationForm.get('shop_comments');
  //         shop_comments.setValue(null);
  //         shop_comments.setValidators([]);
  //         shop_comments.updateValueAndValidity();
  //       } else{
  //         // $("#shop-comments").removeClass('d-none');
  //         this.storeInformationForm.get('allow_shop_comment').setValue(1);
  //       }

  //       if (data.additional_information.length) {
  //         // $("#additioanl-information").removeClass('d-none');
  //         // this.storeInformationForm.get('allow_additional_info').setValue(1);
  //         const controlArray = this.additionalInfo;
  //         data.additional_information.forEach((app) => {
  //           const aif = this.newInfo();
  //           aif.patchValue(app);
  //           controlArray.push(aif);
  //         });
  //         this.deleteAdditionalInfo(0);
  //       } else {
  //         // $("#checkbox-002").slideToggle();
  //         // $("#additioanl-information").hide();
  //         // $("#additioanl-information").addClass('d-none');
  //         // this.storeInformationForm.get('allow_additional_info').setValue(0);
  //       }

  //       // this.storeInformationForm.get('allow_instant_delivery').setValue(1);
  //       // this.storeInformationForm.get('allow_local_delivery').setValue(1);

  //       setTimeout(function () {
  //         $('select[nice-select]').niceSelect('update');
  //       }, 100);

  //     }
  //     this.loaderService.stopLoading();
  //   }, err => {
  //     this.loaderService.stopLoading();
  //   });
  // }

  fetchStoreInfo() {
    this.loaderService.startLoading();

    this.storeInformationService.getProductInfo().subscribe((data: any) => {
      if (!data.error) {
        this.storeInfo = data;
        this.storeInformationForm.patchValue(data);

        if (data.city_id == CITY.JEDDAH) {
          this.isMawjood = true
          // this.isLogistiq = true
        }

        this.coverImageUrl = this.storeInfo.cover_image;

        /** -------------------------
         *   WEEK DAYS / TIME SLOTS
         * ------------------------- */
        if (data.days?.length > 0) {
          this.storeInformationForm.get('week_days.same_everyday')
            .setValue(data.same_everyday);

          this.selectedWeekDays = data.days.map(day => day.day);
          let tempDay = '';
          data.days.forEach(app => {
            const day = app.day;
            if (!day) return;

            // Mark day as available
            const dayGroup = this.storeInformationForm.get(`week_days.${day}`);
            if (!dayGroup) return;

            dayGroup.get('available')?.setValue(true);
            this.timeModel[day] = true;

            const slotsArray = dayGroup.get('slots') as FormArray;
            if(tempDay != day){
              tempDay = day;
              slotsArray.clear(); // Remove default slot(s)
            }

            // Backend may return one or multiple time ranges
            const timeRanges = app.time_ranges ?? [{
              opening_time: app.opening_time,
              closing_time: app.closing_time,
            }];

            timeRanges.forEach(range => {
              const startTime = moment(range.opening_time, 'HH:mm:ss');
              const endTime = moment(range.closing_time, 'HH:mm:ss');

              const slot = this.createSlot();
              slot.patchValue({
                start_time: startTime.format('HH:mm'),
                end_time: endTime.format('HH:mm'),

                new_start_time_group: {
                  hours: startTime.format('HH'),
                  minutes: startTime.format('mm')
                },
                new_end_time_group: {
                  hours: endTime.format('HH'),
                  minutes: endTime.format('mm')
                }
              });

              slotsArray.push(slot);
            });
          });
          this.loadDeliveryDiscounts();
        }

        /** -------------------------
         *   GENERAL STORE INFO
         * ------------------------- */
        this.shopStatus = data.active === 1;
        this.autoAccept = data.auto_accept === 1;

        if (data.country_id == SAUDI_ARABIA) {
          this.outsideSA = false;
        }

        if (data.country_id) {
          this.selectedCountry = {
            id: data.country_id,
            name: data.country_name
          };
          this.storeInformationForm.get('country_id')?.setValue(data.country_id);
          this.onChangeCountry(this.selectedCountry);
        }

        if (data.region_id) {
          this.selectedRegion = {
            id: data.region_id,
            name: data.region_name
          };
          this.storeInformationForm.get('region_id')?.setValue(data.region_id);
        }

        if (data.city_name) {
          this.storeInformationForm.get('city')?.setValue(data.city_name);
        }

        if (data.city_id) {
          this.selectedCity = {
            id: data.city_id,
            name: data.city_name
          };
          this.storeInformationForm.get('city_id')?.setValue(data.city_id);
        }

        if (data.district_id) {
          this.selectedDistrict = {
            id: data.district_id,
            name: data.district_name
          };
          this.storeInformationForm.get('district_id')?.setValue(data.district_id);
        }

        if (data.slug) {
          this.storeUrl = `${environment.baseUrl}/${data.slug}`;
        }

        if (data.product_categories) {
          this.selectedProductCategories = data.product_categories.map(c => c.name);
        }

        if (data.storefront_categories) {
          this.selectedStorefrontCategories = data.storefront_categories;
        }

        /** -------------------------
         *   COMMENTS
         * ------------------------- */
        if (!data.shop_comments) {
          this.storeInformationForm.get('allow_shop_comment')?.setValue(0);
          const shopComments = this.storeInformationForm.get('shop_comments');
          shopComments?.setValue(null);
          shopComments?.setValidators([]);
          shopComments?.updateValueAndValidity();
        } else {
          this.storeInformationForm.get('allow_shop_comment')?.setValue(1);
        }

        /** -------------------------
         *   ADDITIONAL INFO
         * ------------------------- */
        if (data.additional_information?.length) {
          const controlArray = this.additionalInfo;
          data.additional_information.forEach(info => {
            const aif = this.newInfo();
            aif.patchValue(info);
            controlArray.push(aif);
          });
          this.deleteAdditionalInfo(0);
        }

        this.defaultBranch = data?.default_branch;
        this.branches = data?.branches;

        const branches = data?.branches ?? [];
        // if (data?.branches?.length && data.all_enabled) {
        if (branches.length > 1 && data?.all_enabled) {
          this.openBranchModal();
        }

        setTimeout(() => {
          $('select[nice-select]').niceSelect('update');
        }, 100);
      }

      this.loaderService.stopLoading();
    }, err => {
      this.loaderService.stopLoading();
    });
  }

  openBranchModal() {
    const modalRef = this.modalService.open(BranchModalComponent, {backdrop: 'static', keyboard: false});
    modalRef.componentInstance.branches = this.branches;
    modalRef.result.then(
      (result) => {
        if (result?.branches) {
          this.handleUpdatedBranches(result.branches);
        }
      },
      () => {}
    );
  }

  handleUpdatedBranches(updatedBranches: any[]) {
    this.branches = updatedBranches;

    // find selected branch (receives_online_orders = 1)
    const activeBranch = this.branches.find(b => b.receives_online_orders === 1);
    if (activeBranch) {
      this.defaultBranch = activeBranch;
      this.selectedBranchId = activeBranch.id;
    }
  }

  onChangeBranch(event: any) {
    this.selectedBranch = event;
    console.log('Selected Branch:', event);

    Swal.fire({
      title: "Are you sure, you want to change branch",
      icon: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: '#ee3a7a',
      confirmButtonText: "Yes, Update it!",
      cancelButtonText: i18n.cancel
    }).then(result => {
      if (result.value) {
        this.loaderService.startLoading();
        this.storeInformationService.setReceivingBranch({branch_id: this.selectedBranchId}).subscribe(() => {
          // update UI locally
          this.branches = this.branches.map(b => ({
            ...b,
            receives_online_orders: b.id == this.selectedBranchId ? 1 : 0
          }));

          this.handleUpdatedBranches(this.branches);
          this.showBranches = false;

          this.loaderService.stopLoading();
          Swal.fire(i18n.done, 'Default branch updated successfully', 'success');
        });
      } else {
        this.handleUpdatedBranches(this.branches);
        this.showBranches = false;
      }
    });
  }

  changeBranch(type = 'open') {
    if (type == 'open') {
      this.showBranches = true;
    } else if (type == 'close') {
      this.showBranches = false;
    }
  }


  createStoreFormGroup() {
    this.storeInformationForm = this.formBuilder.group({
      name: [null, Validators.required],
      slug: [null, [Validators.required], [uniqueSlugValidator(this.storeInformationService, 'product')]],
      phone: [null, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(5), Validators.maxLength(30)]],
      whatsapp_phone: [null, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(5), Validators.maxLength(30)]],
      shop_type: [STORE_TYPE.PRODUCT],
      description: [null],
      terms_conditions: [null],
      privacy_policy: [null],
      customer_additional_info: [null],
      cover_image: [null],
      additional_info: this.formBuilder.array([
        this.newInfo()
      ]),
      // array: this.array1,
      active: [null],
      storefront_categories: [[], Validators.required],
      product_categories: [[]],
      upload_reference_files: [0],
      allow_additional_info: [1],
      allow_instant_order: [1],
      allow_scheduled_order: [1],
      allow_shop_comment: [0],
      shop_comments: [null, Validators.required],

      building_name: [null, Validators.required],
      street: [null, Validators.required],
      area: [null, Validators.required],
      address: [null, Validators.required],
      region: [null],
      country_id: [null, Validators.required],
      district: [null],
      city: [null],
      city_id: [null],
      region_id: [null],
      district_id: [null],
      pin_drop_location: [null],


      own_delivery: [null],
      same_city: [null],
      same_city_delivery_with: [null],
      outside_city: [null],
      outside_ksa: [null],
      logistiq_email: [null, [Validators.email]],
      logistiq_password: [null],
      delivery_cost_same_city: [null, [Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]],
      delivery_cost_inside_ksa: [null, [Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]],
      delivery_cost_international: [null, [Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]],

      working_days: [[]],
      // start_time: [null,
      //   // ExtraValidators.conditional(
      //   //   (group) => (group.controls.working_days.value?.length || group.controls.end_time.value),
      //   //   Validators.required
      //   // )
      // ],
      // end_time: [null,
      //   // ExtraValidators.conditional(
      //   //   (group) => (group.controls.working_days.value?.length || group.controls.start_time.value),
      //   //   Validators.required
      //   // )
      // ],
      // start_time_group: this.formBuilder.group({
      // 	hours: [null],
      // 	minutes: [null],
      // 	am: [false]
      // }),
      // end_time_group: this.formBuilder.group({
      // 	hours: [null],
      // 	minutes: [null],
      // 	am: [false]
      // }),
      week_days: this.newWeekDays(),

      allow_pick_up: [null],
      pick_up_cost: [null],
      allow_shipping: [null],
      allow_self_manage_delivery: [null],
      self_manage_delivery: this.selfDelivery(),
      allow_instant_delivery: [null],
      allow_local_delivery: [null],
      allow_same_city_delivery: [null],
      instant_delivery: this.instantDelivery(),
      same_city_delivery: this.sameCityDelivery(),

    }
      //, { validator: ExtraValidators.compare('start_time', '<=', 'end_time', 'gte') }
    );
  }

  newInfo(): FormGroup {
    return this.formBuilder.group({
      information: [null],
      make_mandatory: [null],
    })
  }

  newWeekDays(): FormGroup {
    const formGroup = this.formBuilder.group({
      same_everyday: [false], // Checkbox for applying the same time to all days
      monday: this.createDayGroup(),
      tuesday: this.createDayGroup(),
      wednesday: this.createDayGroup(),
      thursday: this.createDayGroup(),
      friday: this.createDayGroup(),
      saturday: this.createDayGroup(),
      sunday: this.createDayGroup(),
    });

    // Listen for changes to 'same_everyday' and update other days accordingly
    formGroup.get('same_everyday')?.valueChanges.subscribe((checked) => {
      if (checked) {
        this.applyMondayToAll(this.storeInformationForm.get('week_days') as FormGroup);
      }
    });

    return formGroup;
  }

  // Create a group for each day
  // createDayGroup(): FormGroup {
  //   return this.formBuilder.group({
  //     available: [null],
  //     start_time: [null],
  //     end_time: [null],
  //     new_start_time_group: this.formBuilder.group({
  //       hours: [null],
  //       minutes: [null],
  //     }),
  //     new_end_time_group: this.formBuilder.group({
  //       hours: [null],
  //       minutes: [null],
  //     }),
  //   }, { validator: ExtraValidators.validateTimeRange('start_time', '<=', 'end_time') });
  //   // }, { validator: ExtraValidators.compare('start_time', '<=', 'end_time', 'gte') });
  // }
  createSlot(): FormGroup {
    const slot = this.formBuilder.group(
      {
        start_time: [null],
        end_time: [null],

        new_start_time_group: this.formBuilder.group({
          hours: [null],
          minutes: ['00'],
        }),

        new_end_time_group: this.formBuilder.group({
          hours: [null],
          minutes: ['00'],
        }),
      },
      {
        validators: [this.validateSlotTime()],
      }
    );

    const updateParent = () => {
      const parentArray = slot.parent as FormArray;
      if (parentArray) {
        parentArray.updateValueAndValidity();
      }
    };

    slot.get('new_start_time_group')?.valueChanges.subscribe(v => {
      if (v.hours != null && v.minutes != null) {
        const time = `${v.hours}:${v.minutes}`;
        slot.get('start_time')?.setValue(time, { emitEvent: false });
        updateParent();
      }
    });

    slot.get('new_end_time_group')?.valueChanges.subscribe(v => {
      if (v.hours != null && v.minutes != null) {
        const time = `${v.hours}:${v.minutes}`;
        slot.get('end_time')?.setValue(time, { emitEvent: false });
        updateParent();
      }
    });

    slot.get('start_time')?.valueChanges.subscribe(() => updateParent());
    slot.get('end_time')?.valueChanges.subscribe(() => updateParent());

    return slot;
  }

  // createDayGroup(): FormGroup {
  //   const group = this.formBuilder.group({
  //     available: [false],
  //     slots: this.formBuilder.array([this.createSlot()], this.validateSlotSequence())
  //   });

  //   group.get('available')?.valueChanges.subscribe(() => {
  //     const slots = group.get('slots') as FormArray;
  //     slots.updateValueAndValidity({ emitEvent: false });
  //   });

  //   return group;
  // }
  createDayGroup(): FormGroup {
    const group = this.formBuilder.group({
      available: [false],
      slots: this.formBuilder.array([this.createSlot()], this.validateSlotSequence())
    });

    // When "available" changes, update slot validations
    group.get('available')?.valueChanges.subscribe((available: boolean) => {
      const slots = group.get('slots') as FormArray;

      slots.controls.forEach(slot => {
        const startCtrl = slot.get('start_time');
        const endCtrl = slot.get('end_time');

        if (available) {
          startCtrl?.setValidators([Validators.required]);
          endCtrl?.setValidators([Validators.required]);
        } else {
          startCtrl?.clearValidators();
          endCtrl?.clearValidators();
        }

        startCtrl?.updateValueAndValidity({ emitEvent: false });
        endCtrl?.updateValueAndValidity({ emitEvent: false });
      });

      slots.updateValueAndValidity({ emitEvent: false });
    });

    return group;
  }


  getSlots(day: string): FormArray {
    return this.storeInformationForm.get('week_days')!.get(day)!.get('slots') as FormArray;
  }

  addSlot(day: string) {
    const slots = this.getSlots(day);
    slots.push(this.createSlot());

    // 🔥 force validate new + previous slot relationship
    slots.updateValueAndValidity();
  }

  removeSlot(day: string, index: number) {
    this.getSlots(day).removeAt(index);
  }

  validateSlotTime() {
    return (group: AbstractControl) => {
      const dayGroup = group.parent?.parent as FormGroup;

      // If not available, skip validation completely
      if (dayGroup && !dayGroup.get('available')?.value) {
        return null;
      }

      const start = group.get('start_time')?.value;
      const end = group.get('end_time')?.value;

      if (!start || !end) return null;

      const [sH, sM] = start.split(':').map(x => +x);
      const [eH, eM] = end.split(':').map(x => +x);

      const startMin = sH * 60 + sM;
      const endMin = eH * 60 + eM;

      return endMin <= startMin ? { timeInvalid: true } : null;
    };
  }


  validateSlotSequence(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!(control instanceof FormArray)) return null;

      const slots = control.controls;
      let hasError = false;

      // Clear previous errors on each slot first
      slots.forEach(slot => {
        if (slot.hasError('slotOrderInvalid')) {
          slot.setErrors(null);
        }
      });

      for (let i = 1; i < slots.length; i++) {
        const prevEnd = slots[i - 1].get('end_time')?.value;
        const currStart = slots[i].get('start_time')?.value;

        if (!prevEnd || !currStart) continue;

        const [pH, pM] = prevEnd.split(':').map(x => +x);
        const [cH, cM] = currStart.split(':').map(x => +x);

        const prevEndMin = pH * 60 + pM;
        const currStartMin = cH * 60 + cM;

        if (currStartMin <= prevEndMin) {
          // Mark error on current slot control
          slots[i].setErrors({ ...(slots[i].errors || {}), slotOrderInvalid: true });
          hasError = true;
        }
      }

      return hasError ? { slotOrderInvalid: true } : null;
    };
  }

  // Function to copy Monday's schedule to all other days
  applyMondayToAll(weekDaysGroup: FormGroup) {
    const mondayGroup = weekDaysGroup.get('monday') as FormGroup;
    const mondaySlots = mondayGroup.get('slots') as FormArray;

    const days = ['tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

    days.forEach(day => {
      const dayGroup = weekDaysGroup.get(day) as FormGroup;
      const daySlots = dayGroup.get('slots') as FormArray;

      // 1️⃣ Copy available toggle
      dayGroup.get('available')!.setValue(mondayGroup.get('available')!.value, { emitEvent: false });

      // 2️⃣ Rebuild slots
      daySlots.clear();

      mondaySlots.controls.forEach((slotCtrl, i) => {
        const slotValue = (slotCtrl as FormGroup).getRawValue();

        const newSlot = this.createSlot();
        newSlot.patchValue(slotValue, { emitEvent: false });

        // 3️⃣ FIX: update derived times
        const start = `${slotValue.new_start_time_group.hours}:${slotValue.new_start_time_group.minutes ?? '00'}`;
        const end   = `${slotValue.new_end_time_group.hours}:${slotValue.new_end_time_group.minutes ?? '00'}`;

        newSlot.get('start_time')!.setValue(start, { emitEvent: false });
        newSlot.get('end_time')!.setValue(end, { emitEvent: false });

        daySlots.push(newSlot);
      });

      // 4️⃣ Validate
      daySlots.updateValueAndValidity({ emitEvent: false });
      dayGroup.updateValueAndValidity({ emitEvent: false });
    });
  }

  // newWeekDays(): FormGroup {
  //   return this.formBuilder.group({
  //     monday: this.formBuilder.group({
  //       available:[null],
  //       start_time:[null],
  //       end_time:[null],
  //       new_start_time_group: this.formBuilder.group({
  //         hours: [null],
  //         minutes: [null],
  //         // am: [false]
  //       }),
  //       new_end_time_group: this.formBuilder.group({
  //         hours: [null],
  //         minutes: [null],
  //         // am: [false]
  //       }),
  //     }, { validator: ExtraValidators.compare('start_time', '<=', 'end_time', 'gte') }),
  //     tuesday: this.formBuilder.group({
  //       available:[null],
  //       start_time:[null],
  //       end_time:[null],
  //       new_start_time_group: this.formBuilder.group({
  //         hours: [null],
  //         minutes: [null],
  //         // am: [false]
  //       }),
  //       new_end_time_group: this.formBuilder.group({
  //         hours: [null],
  //         minutes: [null],
  //         // am: [false]
  //       }),
  //     }, { validator: ExtraValidators.compare('start_time', '<=', 'end_time', 'gte') }),
  //     wednesday: this.formBuilder.group({
  //       available:[null],
  //       start_time:[null],
  //       end_time:[null],
  //       new_start_time_group: this.formBuilder.group({
  //         hours: [null],
  //         minutes: [null],
  //         // am: [false]
  //       }),
  //       new_end_time_group: this.formBuilder.group({
  //         hours: [null],
  //         minutes: [null],
  //         // am: [false]
  //       }),
  //     }, { validator: ExtraValidators.compare('start_time', '<=', 'end_time', 'gte') }),
  //     thursday: this.formBuilder.group({
  //       available:[null],
  //       start_time:[null],
  //       end_time:[null],
  //       new_start_time_group: this.formBuilder.group({
  //         hours: [null],
  //         minutes: [null],
  //         // am: [false]
  //       }),
  //       new_end_time_group: this.formBuilder.group({
  //         hours: [null],
  //         minutes: [null],
  //         // am: [false]
  //       }),
  //     }, { validator: ExtraValidators.compare('start_time', '<=', 'end_time', 'gte') }),
  //     friday: this.formBuilder.group({
  //       available:[null],
  //       start_time:[null],
  //       end_time:[null],
  //       new_start_time_group: this.formBuilder.group({
  //         hours: [null],
  //         minutes: [null],
  //         // am: [false]
  //       }),
  //       new_end_time_group: this.formBuilder.group({
  //         hours: [null],
  //         minutes: [null],
  //         // am: [false]
  //       }),
  //     }, { validator: ExtraValidators.compare('start_time', '<=', 'end_time', 'gte') }),
  //     saturday: this.formBuilder.group({
  //       available:[null],
  //       start_time:[null],
  //       end_time:[null],
  //       new_start_time_group: this.formBuilder.group({
  //         hours: [null],
  //         minutes: [null],
  //         // am: [false]
  //       }),
  //       new_end_time_group: this.formBuilder.group({
  //         hours: [null],
  //         minutes: [null],
  //         // am: [false]
  //       }),
  //     }, { validator: ExtraValidators.compare('start_time', '<=', 'end_time', 'gte') }),
  //     sunday: this.formBuilder.group({
  //       available:[null],
  //       start_time:[null],
  //       end_time:[null],
  //       new_start_time_group: this.formBuilder.group({
  //         hours: [null],
  //         minutes: [null],
  //         // am: [false]
  //       }),
  //       new_end_time_group: this.formBuilder.group({
  //         hours: [null],
  //         minutes: [null],
  //         // am: [false]
  //       }),
  //     }, { validator: ExtraValidators.compare('start_time', '<=', 'end_time', 'gte') }),
  //   })
  // }

  addProduct() {
    let products = this.storeInformationForm.get('products') as FormArray;
    products.push(this.formBuilder.group({
      start_time: [],
      end_time: []
    }));
  }

  selfDelivery(): FormGroup {
    return this.formBuilder.group({
      delivery_cost: [null],
      delivery_radius: [null],
    })
  }

  get selfDeliveryInfo() {
    return this.storeInformationForm.get('self_manage_delivery') as FormGroup;
  }

  getSelfDeliveryFormGroup(index) {
    return this.selfDeliveryInfo.controls[index] as FormGroup;
  }

  deliveryRadius(value) {
    if (value < 0) {
      value = 0;
    } else if (value > 100) {
      value = 100;
    } else if (!value) {
      value = 0;
    }

    this.selfDeliveryInfo.get('delivery_radius')?.setValue(value);
  }

  instantDelivery(): FormGroup {
    return this.formBuilder.group({
      careem: this.careemInstantDelivery(),
      mrsool: this.mrsoolInstantDelivery()
    })
  }

  sameCityDelivery(): FormGroup {
    return this.formBuilder.group({
      mrsool: this.mrsoolInstantDelivery()
    })
  }

  careemInstantDelivery(): FormGroup {
    return this.formBuilder.group({
      enabled: [0],
      careem_discount: [null],
      careem_min_amount: [null],
      careem_min_discount: [null],
      careem_expiry_date: [null],
      careem_expiry_time: [null],
      days: [null], // this.newWeekDays(),
    });
  }

  mrsoolInstantDelivery(): FormGroup {
    return this.formBuilder.group({
      enabled: [0],
      mrsool_discount: [null],
      mrsool_min_amount: [null],
      mrsool_min_discount: [null],
      mrsool_expiry_date: [null],
      mrsool_expiry_time: [null],
      days: [null], // this.newWeekDays(),
    });
  }

  get instantDeliveryInfo() {
    return this.storeInformationForm.get('instant_delivery') as FormGroup;
  }

  getInstantDeliveryInfoFormGroup(index) {
    return this.instantDeliveryInfo.controls[index] as FormGroup;
  }

  changeInstantDelivery(value, option: string) {
    if (option == 'careem') {
      value = (value == 'careem') ? 1 : 0;
      this.getInstantDeliveryInfoFormGroup('careem').get('enabled').setValue(value);
      value = !value;
      this.getInstantDeliveryInfoFormGroup('mrsool').get('enabled').setValue(value);
    }

    if (option == 'mrsool') {
      value = (value == 'mrsool') ? 1 : 0;
      this.getInstantDeliveryInfoFormGroup('mrsool').get('enabled').setValue(value);
      value = !value;
      this.getInstantDeliveryInfoFormGroup('careem').get('enabled').setValue(value);
    }
  }

  get sameCityDeliveryInfo() {
    return this.storeInformationForm.get('same_city_delivery') as FormGroup;
  }

  getSameCityDeliveryInfoFormGroup(index) {
    return this.sameCityDeliveryInfo.controls[index] as FormGroup;
  }

  changeSameCityDelivery(value, option: string) {
    if (option == 'mrsool') {
      value = (value == 'mrsool') ? 1 : 0;
      this.getSameCityDeliveryInfoFormGroup('mrsool').get('enabled').setValue(value);
    }
  }

  get f() {
    return this.storeInformationForm.controls;
  }

  get additionalInfo() {
    return this.storeInformationForm.get('additional_info') as FormArray;
  }

  addAdditionalInfo() {
    this.additionalInfo.push(this.newInfo());
  }

  deleteAdditionalInfo(index) {
    this.additionalInfo.removeAt(index);
  }

  getInformationFormGroup(index) {
    return this.additionalInfo.controls[index] as FormGroup;
  }

  makeMandatory(index, event) {
    const information = this.additionalInfo.controls[index].get('information');
    if (event.target.checked) {
      information.setValidators([Validators.required]);
    } else {
      information.clearValidators();
    }
    information.updateValueAndValidity();
  }

  onChangeCountry(item) {
    let countryId = item.id;
    if (countryId == 682) {
      this.outsideSA = false;
      // this.loaderService.startLoading();
      // this.storeInformationService.getKSACities().subscribe((data: any) => {
      //   this.cities = data;
      //   this.loaderService.stopLoading();
      // }, err => {
      //   this.loaderService.stopLoading();
      //   Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      // })
      this.storeInformationForm.get('city').setValue(null);
      ['city']?.forEach((field: string) => {
        this.storeInformationForm.get(field).setValue(null);
        this.storeInformationForm.get(field).clearValidators();
        this.storeInformationForm.get(field).updateValueAndValidity();
      });
      ['city_id', 'region_id', 'district_id']?.forEach((field: string) => {
        this.storeInformationForm.get(field).setValidators([Validators.required]);
        this.storeInformationForm.get(field).updateValueAndValidity();
      });
    } else {
      this.outsideSA = true;
      ['city'].forEach((field: string) => {
        this.storeInformationForm.get(field).setValidators([Validators.required]);
        this.storeInformationForm.get(field).updateValueAndValidity();
      });

      ['city_id', 'region_id', 'district_id'].forEach((field: string) => {
        this.storeInformationForm.get(field).setValue(null);
        this.storeInformationForm.get(field).clearValidators();
        this.storeInformationForm.get(field).updateValueAndValidity();
      });
    }
  }

  onChangeRegion(item) {
    let region = item.id;
    if (region) {
      this.loaderService.startLoading();
      this.storeInformationService.getCities(region).subscribe((data: any) => {
        this.cities = data;
        this.loaderService.stopLoading();
      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      })
    }
  }

  onChangeCity(item) {
    let city = item.id;
    this.isMawjood = false;
    if (city == CITY.JEDDAH) {
      this.isMawjood = true
    }
    if (city) {
      this.loaderService.startLoading();
      this.storeInformationService.getDistricts(city).subscribe((data: any) => {
        this.districts = data;
        this.loaderService.stopLoading();
      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      })
    }
  }

  onChangeDistrict(item) {

    if (item && item.id && this.storeInformationForm.get('city_id').value == CITY.JEDDAH) {
      this.loaderService.startLoading();
      this.storeInformationService.getDeliveryCostByDistrict(item.id).subscribe((data: any) => {
        this.loaderService.stopLoading();
      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      })
    }
  }

  get startTimeGroup() {
    return this.storeInformationForm.controls.start_time_group;
  }

  get endTimeGroup() {
    return this.storeInformationForm.controls.end_time_group;
  }

  formatSelection(item: any) {
    let dayShortName = item.value.substring(0, 3);
    return dayShortName.replace(/\b\w/g, l => l.toUpperCase()) + ',';
  }

  formatIn24HoursTime(t: any) {
    return moment(`${t.hours}:${t.minutes}:00 ${t.am ? 'AM' : 'PM'}`, 'hh:mm:ss A').format('HH:mm:ss')
  }

  onChangeStartTime() {
    this.storeInformationForm.get('start_time').setValue(this.formatIn24HoursTime(this.startTimeGroup.value));

    let endTime = moment(this.formatIn24HoursTime(this.startTimeGroup.value), 'HH:mm:ss').add(15, 'minutes');
    this.storeInformationForm.get('end_time_group').setValue({
      hours: endTime.format('hh'),
      minutes: endTime.format('mm'),
      am: endTime.hours() < 12
    });

    this.onChangeEndTime();

    setTimeout(function () {
      $('select[nice-select]').niceSelect('update');
    }, 100);
  }

  onChangeEndTime() {
    this.storeInformationForm.get('end_time').setValue(this.formatIn24HoursTime(this.endTimeGroup.value));
  }

  toggleStartTimeAM() {
    this.startTimeGroup.get('am').setValue(!this.startTimeGroup.get('am').value);
    this.onChangeStartTime();
  }

  toggleEndTimeAM() {
    this.endTimeGroup.get('am').setValue(!this.endTimeGroup.get('am').value);
    this.onChangeEndTime();
  }

  onUnselectWorkingDays(data: any) {
    setTimeout(() => {
      let values = this.storeInformationForm.value;
      if (values.working_days && values.working_days.length == 0) {

        this.storeInformationForm.get('start_time_group').reset();
        this.storeInformationForm.get('end_time_group').reset();

        setTimeout(function () {
          $('select[nice-select]').niceSelect('update');
        }, 100);
      }
    }, 100);
  }

  onUnselectProductCategory(data: any) {
    if (this.storeInfo && this.storeInfo.associated_product_categories) {
      if (this.storeInfo.associated_product_categories.indexOf(data.item.name) !== -1) {
        data.event.preventDefault();
        Swal.fire(i18n.error.cant_delete_category, i18n.error.category_associated_with_product, 'error');
      }
    }
  }

  getAllErrors(form: FormGroup | FormArray): { [key: string]: any; } | null {
    let hasError = false;
    const result = Object.keys(form.controls).reduce((acc, key) => {
      const control = form.get(key);
      const errors = (control instanceof FormGroup || control instanceof FormArray) ? this.getAllErrors(control) : control.errors;
      if (errors) {
        acc[key] = errors;
        hasError = true;
      }
      return acc;
    }, {} as { [key: string]: any; });
    return hasError ? result : null;
  }


  onSubmit() {
    this.isSubmitted = true;
    console.log(this.storeInformationForm.valid, this.getAllErrors(this.storeInformationForm));
    if (this.storeInformationForm.valid) {

      let fd = this.storeInformationForm.value;

      if (this.coverImageFile) {
        fd.cover_image = this.coverImageFile;
      }

      if (!this.coverImageUrl) {
        fd.delete_cover_image = true;
      }

      fd.active = this.shopStatus ? 1 : 0;
      fd.auto_accept = this.autoAccept ? 1 : 0;
      fd.upload_reference_files = fd.upload_reference_files ? 1 : 0;
      fd.allow_instant_order = fd.allow_instant_order ? 1 : 0;
      fd.allow_scheduled_order = fd.allow_scheduled_order ? 1 : 0;
      fd.delivery_discount = this.deliveryDiscounts;

      this.loaderService.startLoading();

      // this.storeInformationService.updateProductInfo(fd, { headers: { 'Content-Type': 'multipart/form-data' } })
      this.storeInformationService.updateProductInfo(fd, { headers: { 'Content-Type': 'multipart/form-data' } }).subscribe(
        (res) => {
          this.loaderService.stopLoading();

          let userInfo = this.sharedDataService.getItem('userInfo');
          userInfo.has_store = true;
          this.sharedDataService.setItem('userInfo', userInfo);
          this.basicInfo = userInfo;
          Survicate.showSurvey(environment?.survey?.storefront, { forceDisplay: true });
          Swal.fire(i18n.done, i18n.store.updated, 'success'); //'Store information updated'
          console.log('store-submitted')
        },
        (err) => {
          this.loaderService.stopLoading();
          if (err.status === 422) {
            if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
              let validationErrors = err.error.errors;
              Object.keys(validationErrors).forEach((prop) => {
                this.storeInformationForm.get(prop)?.setErrors({
                  serverError: validationErrors[prop]
                })
              })
            }
          }

          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        }
      )
      this.isSubmitted = false;
    }
  }



  updateDeliveryOption(event) {
    let delivery_cost_same_city = this.storeInformationForm.get('delivery_cost_same_city');
    if (event.target.checked) {
      delivery_cost_same_city.setValidators([Validators.required, Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]);
    } else {
      delivery_cost_same_city.setValue(null);
      delivery_cost_same_city.setValidators([Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]);
    }
    delivery_cost_same_city.updateValueAndValidity();
    // let delivery_cost_same_city = this.storeInformationForm.get('delivery_cost_same_city');
    // let logistiq_email = this.storeInformationForm.get('logistiq_email');
    // let logistiq_password = this.storeInformationForm.get('logistiq_password');
    // let same_city_delivery_with = this.storeInformationForm.get('same_city_delivery_with').value;

    // if (!event.target.checked) {
    //   this.storeInformationForm.get('same_city_delivery_with').setValue(null);
    // }

    // if (event.target.checked && (same_city_delivery_with == 'fixed_cost')) {
    //   delivery_cost_same_city.setValidators([Validators.required, Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]);
    // } else {
    //   delivery_cost_same_city.setValue(null);
    //   delivery_cost_same_city.setValidators([Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]);
    // }

    // if (event.target.checked && (same_city_delivery_with == 'logistiq')) {
    //   logistiq_email.setValidators([Validators.required, Validators.email]);
    //   logistiq_password.setValidators([Validators.required]);
    // } else {
    //   logistiq_email.setValue(null);
    //   logistiq_email.setValidators([Validators.email]);
    //   logistiq_password.setValue(null);
    //   logistiq_password.setValidators([]);
    // }

    // logistiq_email.updateValueAndValidity();
    // logistiq_password.updateValueAndValidity();
    // delivery_cost_same_city.updateValueAndValidity();
  }

  updateLogistiq(event) {
    let delivery_cost_same_city = this.storeInformationForm.get('delivery_cost_same_city');
    let logistiq_email = this.storeInformationForm.get('logistiq_email');
    let logistiq_password = this.storeInformationForm.get('logistiq_password');

    if (event.target.defaultValue == 'logistiq') {
      logistiq_email.setValidators([Validators.required, Validators.email]);
      logistiq_password.setValidators([Validators.required]);
    } else {
      logistiq_email.setValue(null);
      logistiq_email.setValidators([Validators.email]);
      logistiq_password.setValue(null);
      logistiq_password.setValidators([]);
    }

    if (event.target.defaultValue == 'fixed_cost') {
      delivery_cost_same_city.setValidators([Validators.required, Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]);
    } else {
      delivery_cost_same_city.setValue(null);
      delivery_cost_same_city.setValidators([Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]);
    }

    logistiq_email.updateValueAndValidity();
    logistiq_password.updateValueAndValidity();
    delivery_cost_same_city.updateValueAndValidity();
  }

  outsideCityWithinKsa(event) {
    let delivery_cost_inside_ksa = this.storeInformationForm.get('delivery_cost_inside_ksa');
    if (event.target.checked) {
      delivery_cost_inside_ksa.setValidators([Validators.required, Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]);
    } else {
      delivery_cost_inside_ksa.setValue(null);
      delivery_cost_inside_ksa.setValidators([Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]);
    }
    delivery_cost_inside_ksa.updateValueAndValidity();
  }

  outsideKsa(event) {
    let delivery_cost_international = this.storeInformationForm.get('delivery_cost_international');
    if (event.target.checked) {
      delivery_cost_international.setValidators([Validators.required, Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]);
    } else {
      delivery_cost_international.setValue(null);
      delivery_cost_international.setValidators([Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]);
    }
    delivery_cost_international.updateValueAndValidity();
  }

  activateOption(event, option: string) {
    if (option == 'pick-up') {
      let pick_up_cost = this.storeInformationForm.get('pick_up_cost');
      if (event.target.checked) {
        pick_up_cost.setValidators([Validators.required, Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]);
      } else {
        pick_up_cost.setValue(null);
        pick_up_cost.setValidators([Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]);
      }
      pick_up_cost.updateValueAndValidity();
    }

    if (option == 'self-managed') {
      let delivery_cost = this.selfDeliveryInfo.get('delivery_cost');
      let delivery_radius = this.selfDeliveryInfo.get('delivery_radius');

      if (event.target.checked) {
        delivery_cost.setValidators([Validators.required, Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]);
        delivery_radius.setValidators([Validators.required, Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]);
      } else {
        delivery_cost.setValue(null);
        delivery_radius.setValue(null);
        delivery_cost.setValidators([Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]);
        delivery_radius.setValidators([Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]);
      }

      delivery_cost.updateValueAndValidity();
      delivery_radius.updateValueAndValidity();
    }
  }

  toggleSildes(event) {
    $("#" + event.target.attributes["tm-toggle"].value).toggleClass('d-none');
    // $('.mandatory_field').toggleClass('d-none');
  }

  allowShopComments(event) {
    let shop_comments = this.storeInformationForm.get('shop_comments');
    if (event.target.checked) {
      shop_comments.setValidators([Validators.required]);
    } else {
      shop_comments.setValue(null);
      shop_comments.setValidators([]);
    }
    shop_comments.updateValueAndValidity();
  }

  openGoogleMap() {
    const modalRef = this.modalService.open(GoogleLocationModalComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.result.then(result => {
      this.storeInformationForm.get('pin_drop_location').setValue(result.marker);
      this.storeInformationForm.get('address').setValue(result.address);
    })
  }

  copyLink(inputElement?: any) {
    try {
      inputElement.select();
      (document as any).execCommand('copy');
      inputElement.setSelectionRange(0, 0);

      Swal.fire(i18n.done, 'Link copied', 'success');
    } catch (err) {

    }
  }

  copyText() {
    try {
      let selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = this.storeUrl;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
      Swal.fire(i18n.done, 'Link copied', 'success');
    } catch (err) {

    }
  }

  newFormatIn24HoursTime(t: any) {
    return moment(`${t.hours}:${t.minutes}:00}`, 'HH:mm:ss').format('HH:mm:ss')
  }

  get weekDaysInfo() {
    return this.storeInformationForm.get('week_days') as FormGroup;
  }

  getWeekDaysFormGroup(index) {
    return this.weekDaysInfo.controls[index] as FormGroup;
  }

  getNewStartTimeGroup(day) {
    return this.getWeekDaysFormGroup(day).controls.new_start_time_group;
  }

  getNewEndTimeGroup(day) {
    return this.getWeekDaysFormGroup(day).controls.new_end_time_group;
  }

  onChangeNewStartTime(day, type = 'new') {
    // if (day == 'monday') {
    // const startTimeValue = this.storeInformationForm['controls'].week_days['controls'].day['controls'].new_start_time_group.value;
    // const startTimeValue = this.storeInformationForm.controls['week_days'].controls.[day].new_start_time_group.value;
    // }
    const startTimeValue = this.getNewStartTimeGroup(day).value;
    this.storeInformationForm.get('week_days.' + day + '.start_time').setValue(this.newFormatIn24HoursTime(startTimeValue));

    if (type == 'new') {
      let endTime = moment(this.newFormatIn24HoursTime(startTimeValue), 'HH:mm:ss').add(15, 'minutes');
      this.storeInformationForm.get('week_days.' + day + '.new_end_time_group').setValue({
        hours: endTime.format('HH'),
        minutes: endTime.format('mm')
      });
      this.onChangeNewEndTime(day);
    }

    setTimeout(function () {
      $('select[nice-select]').niceSelect('update');
    }, 100);
  }

  onChangeNewEndTime(day) {
    // const endTimeValue = this.storeInformationForm['controls'].week_days['controls'].monday['controls'].new_end_time_group.value;
    const endTimeValue = this.getNewEndTimeGroup(day).value;
    this.storeInformationForm.get('week_days.' + day + '.end_time').setValue(this.newFormatIn24HoursTime(endTimeValue));
  }

  openCloseTimeModel(day: string) {
    this.timeModel[day] = !this.timeModel[day];
  }

  openTimeModel(day: string) {
    this.timeModel[day] = !this.timeModel[day];

    this.getWeekDaysFormGroup(day).get('available').setValue(this.timeModel[day]);
    const start_time = this.getWeekDaysFormGroup(day).get('start_time');
    if (this.timeModel[day] == true) {
      start_time.setValidators([Validators.required]);
    } else {
      start_time.clearValidators();
    }
    start_time.updateValueAndValidity();
  }

  // tabChange(tab) {
  //   this.isSubmitted = true;
  //   if (this.storeInformationForm.valid) {
  //     this.activeTab = tab;
  //   }
  // }

  tabChange(tab, type: string) {
    this.isSubmitted = true;
    // if (this.storeInformationForm.valid) {
    //   this.activeTab = tab;
    // }
    if (this.activeTab == 'general' || (this.activeTab != 'general' && tab == 'general')) {
      if (
        this.storeInformationForm.get('name').valid &&
        this.storeInformationForm.get('slug').valid &&
        this.storeInformationForm.get('phone').valid &&
        this.storeInformationForm.get('storefront_categories').valid &&
        this.storeInformationForm.get('whatsapp_phone').valid &&
        this.storeInformationForm.get('shop_type').valid &&
        this.storeInformationForm.get('description').valid &&
        this.storeInformationForm.get('cover_image').valid &&
        this.storeInformationForm.get('customer_additional_info').valid &&
        this.storeInformationForm.get('additional_info').valid &&
        this.storeInformationForm.get('product_categories').valid &&
        this.storeInformationForm.get('allow_shop_comment').valid &&
        this.storeInformationForm.get('shop_comments').valid &&
        this.storeInformationForm.get('upload_reference_files').valid &&
        this.storeInformationForm.get('allow_additional_info').valid &&
        this.storeInformationForm.get('week_days').valid &&
        this.additionalInfo.valid &&
        this.weekDaysInfo.valid
      ) {
        if (type == 'button') {
          this.onSubmit();
        }
        this.activeTab = tab;
      } else {
        this.markFieldsAsTouched(['name', 'slug', 'phone', 'storefront_categories', 'whatsapp_phone', 'shop_type', 'description', 'cover_image', 'customer_additional_info', 'additional_info', 'service_categories', 'allow_shop_comment', 'shop_comments', 'upload_reference_files', 'allow_additional_info', 'week_days']);
        console.log(this.getSlots);
      }
    }

    else if (this.activeTab == 'store-address' || (this.activeTab == 'product-listing' && tab == 'store-address')) {
      if (
        this.storeInformationForm.get('building_name').valid &&
        this.storeInformationForm.get('street').valid &&
        this.storeInformationForm.get('area').valid &&
        this.storeInformationForm.get('address').valid &&
        this.storeInformationForm.get('region').valid &&
        this.storeInformationForm.get('country_id').valid &&
        this.storeInformationForm.get('district').valid &&
        this.storeInformationForm.get('city').valid &&
        this.storeInformationForm.get('city_id').valid &&
        this.storeInformationForm.get('region_id').valid &&
        this.storeInformationForm.get('district_id').valid &&
        this.storeInformationForm.get('pin_drop_location').valid
      ) {
        if (type == 'button') {
          this.onSubmit();
        }
        this.activeTab = tab;
      } else {
        this.markFieldsAsTouched(['building_name', 'street', 'area', 'address', 'region', 'country_id', 'district', 'city', 'city_id', 'region_id', 'district_id', 'pin_drop_location']);
      }
    }

    else if (this.activeTab == 'product-listing' || (this.activeTab == 'delivery-options' && tab == 'product-listing')) {
      this.activeTab = tab;
      this.productListingType = 'manual';
      if (this.foodicsAvailble()) {
        this.productListingType = 'foodics';
      }
    }

    else if (this.activeTab == 'delivery-options' || (this.activeTab == 'store-address' && tab == 'delivery-options')) {
      if (
        this.storeInformationForm.get('own_delivery').valid &&
        this.storeInformationForm.get('same_city').valid &&
        this.storeInformationForm.get('same_city_delivery_with').valid &&
        this.storeInformationForm.get('outside_city').valid &&
        this.storeInformationForm.get('outside_ksa').valid &&
        this.storeInformationForm.get('logistiq_email').valid &&
        this.storeInformationForm.get('logistiq_password').valid &&
        this.storeInformationForm.get('delivery_cost_same_city').valid &&
        this.storeInformationForm.get('delivery_cost_inside_ksa').valid &&
        this.storeInformationForm.get('delivery_cost_international').valid
      ) {
        if (type == 'button') {
          this.onSubmit();
        }
        this.activeTab = tab;
      } else {
        this.markFieldsAsTouched(['own_delivery', 'same_city', 'same_city_delivery_with', 'outside_city', 'outside_ksa', 'logistiq_email', 'logistiq_password', 'delivery_cost_same_city', 'delivery_cost_inside_ksa', 'delivery_cost_international']);
      }
    }

    if (this.activeTab == 'marketing') {
      this.activeTab = tab;
    }

  }

  markFieldsAsTouched(fields: string[]) {
    fields.forEach(field => {
      this.storeInformationForm.get(field)?.markAsTouched();
    });
  }

  validateInput(event: KeyboardEvent): void {
    const inputChar = String.fromCharCode(event.charCode);

    // Regular expression to allow only English, Arabic characters and numbers
    const regex = /^[\u0621-\u064A\u0660-\u0669A-Za-z0-9 ]+$/;

    if (!regex.test(inputChar)) {
      event.preventDefault(); // Block the input if it's not a valid character
    }
  }

  showFoodicsPaymentTab(): boolean {
    if (this.basicInfo?.marketplace_model?.foodics_is_active && this.basicInfo?.subscription.subscription_status != 'free') {
      this.foodicsEnabled = true;
      return true;
    }
    else {
      this.foodicsEnabled = false;
      return false;
    }
  }

  foodicsAvailble(): boolean {
    if (this.basicInfo?.marketplace_model?.foodics_is_active && this.basicInfo?.marketplace_model?.foodics_is_enable) {
      // this.foodicsEnabled = true;
      return true;
    }
    else {
      // this.foodicsEnabled = false;
      return false;
    }
  }

  changeProductListingType(type: string) {
    // if (type == 'manual') {
    //   this.router.navigateByUrl('products');
    // }
    this.productListingType = type;
  }

  generateAuthUrl() {
    this.loaderService.startLoading();
    const foodicsUrl = environment.foodicsUrl;
    const teemUrl = environment.baseUrl;
    const clinetId = environment.clientId;
    const query = new URLSearchParams({
      'client_id': clinetId,
      "redirect_uri": `${teemUrl}/foodics/callback`,
      "response_type": "code",
      // "scope": "",
      "state": this.basicInfo.uuid // this.randomString(40)
    }).toString();
    (window as any).open(`${foodicsUrl}/authorize?${query}`, '_self');
  }

  onChangeProductListingType(type: any) {
    console.log(type)
    this.productListingType = type;
  }

  onSelectProducts(products: Array<any>) {
    this.loaderService.startLoading();
    this.activeTab = 'general';
    this.storeInformationService.updateFoodicsProducts(products).subscribe(
      (res) => {
        this.loaderService.stopLoading();
        this.activeTab = 'product-listing';
        this.productListingType = 'foodics';
        this.foodicsDataFetched = true;
        this.basicInfo.marketplace_model.foodics_is_enable = true;
        this.basicInfo.marketplace_model.foodics_is_active = true;
        Swal.fire(i18n.done, i18n.store.updated, 'success');
      },
      (err) => {
        this.loaderService.stopLoading();
        if (err.status === 422) {
          if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
            let validationErrors = err.error.errors;
            Object.keys(validationErrors).forEach((prop) => {
              this.storeInformationForm.get(prop)?.setErrors({
                serverError: validationErrors[prop]
              })
            })
          }
        }
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      }
    )
  }

  onDisconnectFoodics() {
    Swal.fire({
      title: i18n.are_you_sure,
      text: i18n.store.you_want_to_disconnect_foodics,
      // icon: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#EB1461",
      confirmButtonText: i18n.yes,
      cancelButtonText: i18n.no_cancel_it,
      customClass: { cancelButton: 'custom_swal_cancel' }
    }).then(result => {
      if (result.value) {
        this.loaderService.startLoading();
        this.storeInformationService.disconnectFoodics().subscribe((res) => {
          this.loaderService.stopLoading();
          this.basicInfo.marketplace_model.foodics_is_enable = 0;
          this.productListingType = null;
          this.foodicsDataFetched = false;
          Swal.fire(i18n.done, i18n.store.updated, 'success');
        }, (err) => {
          this.loaderService.stopLoading();
          this.basicInfo.marketplace_model.foodics_is_enable = 1;
          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        });
      }
    });
  }

  addSelectDelivery(form: FormGroup) {

  }

  openDeliveryDiscountModel(formGp: string, deliveryType: string, editIndex: number = -1) {
    const modalRef = this.modalService.open(DeliveryComponent, { windowClass: 'delivery-modal-popup' });

    // Create fresh empty form for new discount or load existing for edit
    if (editIndex === -1) {
      // Creating new discount - empty form
      const tomorrow = moment().add(1, 'days');
      this.deliveryForm = this.formBuilder.group({
        days: this.newWeekDays(),
        delivery_discount: [null, [Validators.min(0.01), Validators.required]],
        discount_expiry: [tomorrow.format('YYYY-MM-DD'), Validators.required],
        discount_expiry_time: [tomorrow.format('HH:mm:ss')],
        discount_expiry_time_group: this.formBuilder.group({
          hours: [tomorrow.format('HH')],
          minutes: [tomorrow.format('mm')],
        }),
        minimum_order_size: [null, [Validators.min(0.01), Validators.required]],
        minimum_discount_size: [null, [Validators.min(0.01), Validators.required]]
      });
    } else {
      // Editing existing discount
      const key = `${formGp}_${deliveryType}`;
      const discountData = this.deliveryDiscounts[key][editIndex];
      
      let expirydate = moment(discountData.discount_expiry);
      this.deliveryForm = this.formBuilder.group({
        days: this.newWeekDays(),
        delivery_discount: [discountData.delivery_discount, [Validators.min(0.01), Validators.required]],
        discount_expiry: [expirydate.format('YYYY-MM-DD'), Validators.required],
        discount_expiry_time: [expirydate.format('HH:mm:ss')],
        discount_expiry_time_group: this.formBuilder.group({
          hours: [expirydate.format('HH')],
          minutes: [expirydate.format('mm')],
        }),
        minimum_order_size: [discountData.minimum_order_size, [Validators.min(0.01), Validators.required]],
        minimum_discount_size: [discountData.minimum_discount_size, [Validators.min(0.01), Validators.required]],
        id:[discountData.id]
      });

      // Populate days data for editing
      if (discountData.days) {
        Object.keys(discountData.days).forEach(day => {
          const dayData = discountData.days[day];
          if (dayData.available) {
            let startTime = moment(dayData.start_time, 'HH:mm:ss');
            let endTime = moment(dayData.end_time, 'HH:mm:ss');

            this.deliveryForm.get('days.'+day+'.available').setValue(true);
            this.deliveryForm.get('days.'+day+'.start_time').setValue(startTime.format('HH:mm:ss'));
            this.deliveryForm.get('days.'+day+'.end_time').setValue(endTime.format('HH:mm:ss'));

            this.deliveryForm.get('days.'+day+'.new_start_time_group').setValue({
              hours: startTime.format('HH'),
              minutes: startTime.format('mm')
            });

            this.deliveryForm.get('days.'+day+'.new_end_time_group').setValue({
              hours: endTime.format('HH'),
              minutes: endTime.format('mm')
            });

            this.timeModel[day] = true;
          }
        });
      }
    }
    
    modalRef.componentInstance.formType = null;
    modalRef.componentInstance.storeInformationForm = this.storeInformationForm;
    modalRef.componentInstance.form = this.deliveryForm;
    modalRef.componentInstance.formId = deliveryType;
    
    modalRef.result.then(result => {
      this.onDeliveryDiscount(result, formGp, deliveryType, editIndex)
    }, fallbackResult => {
      // Modal dismissed
    });
  }

  onDeliveryDiscount(form: FormGroup, formGp: string, deliveryType: string, editIndex: number = -1) {
    console.log('onDeliveryDiscount form');
    console.log(form.value);

    let fullExpiryDateTime = form.value.discount_expiry;
    if (form.value?.discount_expiry_time) {
      let expirydate = moment(fullExpiryDateTime, 'YYYY-MM-DD');
      let expiryTime = moment(form.value.discount_expiry_time, 'HH:mm:ss');
      fullExpiryDateTime = expirydate.format('YYYY-MM-DD') + ' ' + expiryTime.format('HH:mm:ss');
    }
    
    // Save to localStorage array
    const key = `${formGp}_${deliveryType}`;
    const discountData = {
      delivery_discount: form.value.delivery_discount,
      discount_expiry: fullExpiryDateTime,
      minimum_order_size: form.value.minimum_order_size,
      minimum_discount_size: form.value.minimum_discount_size,
      days: form.value.days,
      created_at: editIndex === -1 ? moment().format('YYYY-MM-DD HH:mm:ss') : this.deliveryDiscounts[key][editIndex].created_at,
      id:form.value.id
    };
    
    if (!this.deliveryDiscounts[key]) {
      this.deliveryDiscounts[key] = [];
    }
    
    if (editIndex === -1) {
      // Add new discount
      this.deliveryDiscounts[key].push(discountData);
      console.log('Added new discount to key:', key);
    } else {
      // Update existing discount
      this.deliveryDiscounts[key][editIndex] = discountData;
      console.log('Updated discount at index:', editIndex, 'for key:', key);
    }
    
    console.log('Current deliveryDiscounts:', this.deliveryDiscounts);
    console.log('Discounts for key', key, ':', this.deliveryDiscounts[key]);
    // this.saveDeliveryDiscounts();
    
    if (formGp == 'instant_delivery') {
      if (deliveryType == 'mrsool') {
        // this.getInstantDeliveryInfoFormGroup('careem').get('enabled').setValue(0);
        this.getInstantDeliveryInfoFormGroup('mrsool').get('enabled').setValue(1);
        this.getInstantDeliveryInfoFormGroup('mrsool').get('days').setValue(form.value.days);
        this.getInstantDeliveryInfoFormGroup('mrsool').get('mrsool_discount').setValue(form.value.delivery_discount);
        this.getInstantDeliveryInfoFormGroup('mrsool').get('mrsool_min_amount').setValue(form.value.minimum_order_size);
        this.getInstantDeliveryInfoFormGroup('mrsool').get('mrsool_min_discount').setValue(form.value.minimum_discount_size);
        this.getInstantDeliveryInfoFormGroup('mrsool').get('mrsool_expiry_date').setValue(fullExpiryDateTime);
        this.getInstantDeliveryInfoFormGroup('mrsool').get('mrsool_expiry_time').setValue(form.value.discount_expiry_time);
        // this.getInstantDeliveryInfoFormGroup('mrsool').get('mrsool_discount_expiry').setValue(form.value.discount_expiry);
      }

      if (deliveryType == 'careem') {
        // this.getInstantDeliveryInfoFormGroup('mrsool').get('enabled').setValue(0);
        this.getInstantDeliveryInfoFormGroup('careem').get('enabled').setValue(1);
        this.getInstantDeliveryInfoFormGroup('careem').get('days').setValue(form.value.days);
        this.getInstantDeliveryInfoFormGroup('careem').get('careem_discount').setValue(form.value.delivery_discount);
        this.getInstantDeliveryInfoFormGroup('careem').get('careem_min_amount').setValue(form.value.minimum_order_size);
        this.getInstantDeliveryInfoFormGroup('careem').get('careem_min_discount').setValue(form.value.minimum_discount_size);
        this.getInstantDeliveryInfoFormGroup('careem').get('careem_expiry_date').setValue(fullExpiryDateTime);
        this.getInstantDeliveryInfoFormGroup('careem').get('careem_expiry_time').setValue(form.value.discount_expiry_time);
        // this.getInstantDeliveryInfoFormGroup('careem').get('careem_discount_expiry').setValue(form.value.discount_expiry);
      }
    }
    
    if (formGp == 'same_city_delivery') {
      if (deliveryType == 'mrsool') {
        // this.getSameCityDeliveryInfoFormGroup('careem').get('enabled').setValue(0);
        this.getSameCityDeliveryInfoFormGroup('mrsool').get('enabled').setValue(1);
        this.getSameCityDeliveryInfoFormGroup('mrsool').get('days').setValue(form.value.days);
        this.getSameCityDeliveryInfoFormGroup('mrsool').get('mrsool_discount').setValue(form.value.delivery_discount);
        this.getSameCityDeliveryInfoFormGroup('mrsool').get('mrsool_min_amount').setValue(form.value.minimum_order_size);
        this.getSameCityDeliveryInfoFormGroup('mrsool').get('mrsool_min_discount').setValue(form.value.minimum_discount_size);
        this.getSameCityDeliveryInfoFormGroup('mrsool').get('mrsool_expiry_date').setValue(fullExpiryDateTime);
        this.getSameCityDeliveryInfoFormGroup('mrsool').get('mrsool_expiry_time').setValue(form.value.discount_expiry_time);
        // this.getSameCityDeliveryInfoFormGroup('mrsool').get('mrsool_discount_expiry').setValue(form.value.discount_expiry);
      }
    }
    
    // this.getInstantDeliveryInfoFormGroup(deliveryType).patchValue(mrsool)
    console.log('this.storeInformationForm');
    console.log(this.storeInformationForm);
    // this.onSubmit()
    this.onSubmit();
  }

  openOtoAccount(type: string) {
    this.showOtoFrom = true;
    this.otoAccountType = type;
  }

  removeOtoAccount() {

  }

  ngOnDestroy() {
    this.routeSubscriber.unsubscribe();
  }

  onApplyBranch() {
    Swal.fire({
      title: i18n.are_you_sure,
      text: i18n.store.you_want_to_apply_branch,
      // icon: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#EB1461",
      confirmButtonText: i18n.yes,
      cancelButtonText: i18n.no_cancel_it,
      customClass: { cancelButton: 'custom_swal_cancel' }
    }).then(result => {
      if (result.value) {
        this.loaderService.startLoading();
        this.setBranches();
      }
    });
  }

  onDeactivateBranch() {
    Swal.fire({
      title: i18n.are_you_sure,
      text: i18n.store.you_want_to_deactivate_branch,
      // icon: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: "#EB1461",
      confirmButtonText: i18n.yes,
      cancelButtonText: i18n.no_cancel_it,
      customClass: { cancelButton: 'custom_swal_cancel' }
    }).then(result => {
      if (result.value) {
        this.loaderService.startLoading();
        this.setBranches(0);
      }
    });
  }

  gotoStore() {
    window.location.href = '/store';
  }

  setBranches(value: any = 1) {
    this.storeService.setStoreAsBranches({ 'is_branch': value }).subscribe((data: any) => {
      this.loaderService.stopLoading();
      if (data.status == 'success') {
        this.gotoStore()
        Swal.fire(i18n.done, i18n.store.updated, 'success');
      }
    }, (err) => {
      this.loaderService.stopLoading();
      Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
    });
  }

  // Load delivery discounts from localStorage
  loadDeliveryDiscounts() {
    const storedDiscounts = this.storeInfo.delivery_discount;
    if (storedDiscounts) {
      try {
        this.deliveryDiscounts = storedDiscounts;
      } catch (e) {
        this.deliveryDiscounts = {};
      }
    }
  }

  // Save delivery discounts to localStorage
  // saveDeliveryDiscounts() {
  //   localStorage.setItem('deliveryDiscounts', JSON.stringify(this.deliveryDiscounts));
  // }

  // Check if discount exists for a delivery type
  hasDeliveryDiscount(deliveryType: string, partner: string): boolean {
    const key = `${deliveryType}_${partner}`;
    return this.deliveryDiscounts[key] && Array.isArray(this.deliveryDiscounts[key]) && this.deliveryDiscounts[key].length > 0;
  }

  // Get all discounts for a delivery type
  getDeliveryDiscounts(deliveryType: string, partner: string): any[] {
    const key = `${deliveryType}_${partner}`;
    return this.deliveryDiscounts[key] || [];
  }

  // Delete discount by index
  deleteDeliveryDiscount(deliveryType: string, partner: string, index: number) {
    const key = `${deliveryType}_${partner}`;
    if (this.deliveryDiscounts[key] && this.deliveryDiscounts[key][index] !== undefined) {
      this.deliveryDiscounts[key].splice(index, 1);
      // this.saveDeliveryDiscounts();
    }
  }

  // Edit discount by index
  editDeliveryDiscount(deliveryType: string, partner: string, index: number) {
    this.openDeliveryDiscountModel(deliveryType, partner, index);
  }

  // Format days for display
  formatDiscountDays(days: any): string {
    if (!days) return '';
    
    const activeDays = Object.keys(days)
      .filter(day => days[day].available)
      .map(day => day.charAt(0).toUpperCase() + day.slice(1, 3));
    
    if (activeDays.length === 7) {
      return 'Everyday';
    } else if (activeDays.length === 5 && !days.saturday?.available && !days.sunday?.available) {
      return 'Mon - Fri';
    } else if (activeDays.length === 2 && days.saturday?.available && days.sunday?.available) {
      return 'Sat - Sun';
    } else if (activeDays.length > 0) {
      return activeDays.join(', ');
    }
    
    return '';
  }

  // Format time ranges for display
  formatDiscountTimeRanges(days: any): string[] {
    if (!days) return [];
    
    const timeRanges: string[] = [];
    Object.keys(days).forEach(day => {
      if (days[day].available && days[day].start_time && days[day].end_time) {
        const range = `${days[day].start_time.substring(0, 5)} to ${days[day].end_time.substring(0, 5)}`;
        if (!timeRanges.includes(range)) {
          timeRanges.push(range);
        }
      }
    });
    
    return timeRanges;
  }

  // Format discount date range for display (created_at to discount_expiry)
  formatDiscountDateRange(discount: any): string {
    if (!discount) return '';
    
    const createdDate = discount.created_at ? moment(discount.created_at).format('DD.MM.YYYY') : '';
    const expiryDate = discount.discount_expiry ? moment(discount.discount_expiry).format('DD.MM.YYYY') : '';
    
    if (createdDate && expiryDate) {
      return `${createdDate} to ${expiryDate}`;
    }
    
    return '';
  }
}
